var bpfrpt_proptype_ScrollIndices = process.env.NODE_ENV === 'production' ? null : {
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};
import PropTypes from "prop-types";
export { bpfrpt_proptype_ScrollIndices };


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/es/ArrowKeyStepper/types.js
// module id = 775
// module chunks = 1